const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  width: 16rem;
  background-color: var(--goto-ui-base-01);
  padding-top: var(--goto-spacing-06);
  display: inline-flex;
  flex-direction: column;
}
:host slot {
  display: inline-flex;
  flex-direction: column;
}

::slotted(chameleon-accordion) {
  outline: 0;
}

::slotted(chameleon-accordion-item) {
  margin-left: var(--goto-spacing-05);
}`; export default styles;